export default {
  cashOrders(state) {
    return state.cashOrders
  },
  paymentRequests(state) {
    return state.paymentRequests
  },
  paymentRequestCounter(state) {
    return state.paymentRequestCounter
  },
  paymentRequestFilters(state) {
    return state.paymentRequestFilters
  },
  cashCounter(state) {
    return state.cashCounter
  },
  cashSummary(state) {
    return state.cashSummary
  },
  orders(state) {
    return state.orders
  },
  certifications(state) {
    return state.certifications
  },
  cashOrder(state) {
    return state.cashOrder
  },
  orderHistory(state) {
    return state.orderHistory
  },
  operations(state) {
    return state.operations
  },
  basis(state) {
    return state.basis
  },
  salary(state) {
    return state.salary
  },
  salaries(state) {
    return state.salaries
  },
  cleanCashOrder(state) {
    return state.cleanCashOrder
  },
  orderFilters(state) {
    return state.orderFilters
  },
  certificateFilters(state) {
    return state.certificateFilters
  },
  certificateListFilters(state) {
    return state.certificateListFilters
  },
  paymentTypes(state) {
    return state.paymentTypes
  },
  orderItemTypes(state) {
    return state.orderItemTypes
  },
  ordersCounter(state) {
    return state.ordersCounter
  },
  ordersSummary(state) {
    return state.ordersSummary
  },
  orderStatuses(state) {
    return state.orderStatuses
  },
  paymentStatuses(state) {
    return state.paymentStatuses
  },
  paymentTypes_get(state) {
    return state.paymentTypes_get
  },
  orderDoneStatuses(state) {
    return state.orderDoneStatuses
  },
  cashOrdersFilters(state) {
    return state.cashOrdersFilters
  },
}
